// extracted by mini-css-extract-plugin
module.exports = {"accountName":"LinkedAccountName__accountName__Iq3-H","note":"LinkedAccountName__note__XpBLZ"};